<!-- left-sidebar-1 -->
<div class="left-sidebar left-sidebar-1">
  <div class="wrapper">
    <div class="content">
      <div class="ctrl-board-wrapper d-lg-none text-center d-flex justify-content-between">
        <button class="btn filter-btn" (click)="resetAll($event)" translate>Clear All</button>
        <h5 translate>Filter</h5>
        <button class="btn filter-btn" (click)="sharedData.isFilterOpen=!sharedData.isFilterOpen" translate>Done</button>
      </div>
      <div class="sidebar-search section" filterMenu="filter-menu" [ngClass]="{'d-none': sharedData.isMobileMode()}">
        <label class="label-results-search" translate >Results search</label>
        <sidebar-search [key]="kw"></sidebar-search>
        @if (!sharedData.isMobileMode()) {
          @if (!sharedData.isMobileMode()) {
            <ul class="list-unstyled">
              <tree-view #treeView [standAlone]="true" (loadGroup)="onLoadGroup($event)">
                <div treeViewBottomContent>
                  <ng-content select="[treeViewBottomContent]"></ng-content>
                </div>
              </tree-view>
            </ul>
          }
        }
      </div>
      @if (sharedData.isMobileMode()) {
        <accordion [ngClass]="{'d-none': hasNoFilters() || isLeafGroup }">
          <accordion-group #g_cs [isOpen]="true">
            <div accordion-heading>
              <span class="mx-2" translate>Filter By Catalogue</span>
              <i class="pull-right fa"
                  [ngClass]="{'fa-minus-square-o': g_cs?.isOpen&&!sharedData.isMobileMode(),
                  'fa-plus-square-o': !g_cs?.isOpen&&!sharedData.isMobileMode(),
                  'fa-angle-down': !g_cs?.isOpen&&sharedData.isMobileMode(),
                  'fa-angle-up': g_cs?.isOpen&&sharedData.isMobileMode()}">
              </i>
            </div>
            <div>
              <tree-view #treeView (loadGroup)="onLoadGroup($event)">
              </tree-view>
            </div>
          </accordion-group>
        </accordion>
      }
      @if (showSortOptions) {
        <sort></sort>
      }
      <filters [mode]="'accordion'" #filtersComponent
        [facets]="filterFacet"
        [checkedFacets]="filtersData"
        [currentGroupId]="currentGroupId"
        [ngClass]="['level-' + currentGroupId + '-group']"
      ></filters>
    </div>
    <cms title="ngx-filter-bottom" class="cms-filter-bottom"></cms>
  </div>
</div>
<!-- end left-sidebar-1 -->
